export default __webpack_public_path__ + "static/media/cif-ht.5b4b056b.svg";